module.exports = __webpack_public_path__ + "img/nocollect.68e440b5.svg";